// components/journey-surface/journey-collapsed-rail.js
// ═══════════════════════════════════════════════════════
// Collapsed (narrow rail) state of the journey map panel.
// Shows a stacked JOURNEY label and a node count at the bottom.

import React from 'react';

export function JourneyCollapsedRail({ thinking, nodes, onToggle }) {
  return (
    <div
      style={{
        width: '100%',
        flexShrink: 0,
        background: '#07070a',
        borderLeft: thinking ? '1px solid #c8a96e' : '1px solid #1e1e2a',
        boxShadow: thinking ? 'inset 0 0 10px rgba(200,169,110,0.18)' : 'none',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        paddingTop: 14,
        animation: thinking ? 'wsmap-pulse 1.2s ease-in-out' : 'none',
        transition: 'border-color 0.3s, box-shadow 0.3s',
      }}
    >
      <style jsx global>{`
        @keyframes wsmap-pulse {
          0%, 100% { box-shadow: inset 0 0 4px rgba(200,169,110,0.1); }
          50% { box-shadow: inset 0 0 14px rgba(200,169,110,0.32); }
        }
        @keyframes wsmap-node-in {
          from { opacity: 0; transform: scale(0.6); }
          to { opacity: 1; transform: scale(1); }
        }
        @keyframes wsmap-status-pulse {
          0%, 100% { opacity: 0.3; }
          50% { opacity: 1; }
        }
      `}</style>
      <button
        onClick={onToggle}
        title="Expand journey map"
        style={{
          background: 'none',
          border: '1px solid #2a2a2a',
          borderRadius: 4,
          width: 28,
          height: 28,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 0,
        }}
        onMouseEnter={e => { e.currentTarget.style.borderColor = '#7a9e82'; }}
        onMouseLeave={e => { e.currentTarget.style.borderColor = '#2a2a2a'; }}
      >
        <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
          <circle cx="4" cy="4" r="1.8" stroke="#7a9e82" strokeWidth="1" />
          <circle cx="12" cy="4" r="1.8" stroke="#c8a96e" strokeWidth="1" />
          <circle cx="8" cy="11" r="1.8" stroke="#9b8fc4" strokeWidth="1" />
          <line x1="4" y1="4" x2="8" y2="11" stroke="#2a2a2a" strokeWidth="0.8" />
          <line x1="12" y1="4" x2="8" y2="11" stroke="#2a2a2a" strokeWidth="0.8" />
        </svg>
      </button>
      {/* Letters stacked vertically but each letter upright — no
          rotated text, no head-tilting. Splits the word into chars
          and stacks them in a flex column. */}
      <div style={{
        marginTop: 16,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1,
        fontSize: 9,
        color: '#555',
        fontFamily: 'Georgia, serif',
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
        lineHeight: 1.1,
      }}>
        {'JOURNEY'.split('').map((char, i) => (
          <span key={i}>{char}</span>
        ))}
      </div>
      {nodes && nodes.length > 0 && (
        <div style={{
          marginTop: 'auto',
          marginBottom: 14,
          fontSize: 9,
          color: '#666',
          fontFamily: 'Georgia, serif',
        }}>
          {nodes.length}
        </div>
      )}
    </div>
  );
}
